import React, { useCallback, useState } from 'react'

import { getFileName, getFileUrl, handleDownloadFile, handleUploadFiles } from './utils'

import { AssetFile } from '~generated/types'
import AssetsInput from '~lib/ui-kit/AssetsInput'
import AssetPreviewModal from '~modules/assetModules/elements/AssetPreviewModal'

interface AssetModulesInputProps {
  defaultValue?: AssetFile[]
  readOnly?: boolean
  value?: AssetFile[]
  detailed?: boolean
  carouselView?: boolean
  hideAssets?: boolean
  onChange?: (files: AssetFile[]) => void
  onLoadingChange?: (value: boolean) => void
}

// const ACCEPTED_FILE_TYPES = [
//   'image/jpeg',
//   'image/jpg',
//   'image/png',
//   'video/mp4',
//   '.mov',
//   '.pdf',
//   '.gif',
//   '.svg',
//   // Word
//   '.doc',
//   'docx',
//   // PowerPoint
//   '.ppt',
//   '.pptx',
//   '.pps',
//   '.ppsx',
//   // Excel File Formats
//   'application/vnd.ms-excel',
//   'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//   '.xls',
//   '.xlsx',
//   '.xlsm',
//   'application/vnd.oasis.opendocument.spreadsheet', // OpenDocument .ods
// ]

function UploadAssetsInput(
  {
    readOnly,
    defaultValue,
    detailed,
    value,
    carouselView,
    hideAssets,
    onChange,
    onLoadingChange,
  }: AssetModulesInputProps,
  ref: React.ForwardedRef<HTMLInputElement>
) {
  const [showPreview, setShowPreview] = useState({
    opened: false,
    index: -1,
  })

  const openPreview = useCallback((index: number) => {
    setShowPreview({ opened: true, index })
  }, [])

  const closePreview = useCallback(() => {
    setShowPreview({ opened: false, index: -1 })
  }, [])

  return (
    <>
      <AssetsInput
        ref={ref}
        // FIXME handle MIME types on the backend, because of blockers in browsers
        // we can't use accept here
        // see https://github.com/react-dropzone/react-dropzone/issues/991#issuecomment-664256221
        // accept={ACCEPTED_FILE_TYPES}
        defaultValue={defaultValue}
        getName={getFileName}
        getUrl={getFileUrl}
        value={value}
        onChange={onChange}
        readOnly={readOnly}
        onUpload={handleUploadFiles}
        onClickAsset={openPreview}
        carouselView={carouselView}
        detailed={detailed}
        hideAssets={hideAssets}
        onLoadingChange={onLoadingChange}
      />

      {showPreview.opened && (
        <AssetPreviewModal
          initialFileIndex={showPreview.index}
          onClose={closePreview}
          files={value}
          onDownload={handleDownloadFile}
        />
      )}
    </>
  )
}

export default React.forwardRef(UploadAssetsInput)
